import "./BreadcrumbsLoader.scss";
import {FaChevronRight} from "react-icons/fa";

const BreadcrumbsLoader = () => {
    return (
        <div className="breadcrumbs-loader">
            <FaChevronRight className="fas fa-chevron-right fa-xs mr-1 text-muted" size={'1rem'}/>
            <div className="breadcrumbs-loader__crumb"></div>
        </div>
    )
}

export default BreadcrumbsLoader;